import {getParentActivitiesForStudents} from "../../../../services/API";
import { getSchoolYear } from "../../util/validation";

/**
 * fetch the latest assessments for a student
 * @param {*} studentId
 * @param {*} equating
 * @param {*} locale
 * @param {*} limit
 * @returns
 */
export default async function getLatestAssessments(studentId, equating, locale, limit) {
  const statuses = ["not_started","scored"];
  const displayStatuses = ["completed","rescored","prereader"];
  const { startDate, endDate } = getSchoolYear();
  const assessments = await getParentActivitiesForStudents([{id: studentId}], limit, ["assessment", "dyslexia", "letterNamingAndSounds"], equating, locale, startDate, endDate, statuses, displayStatuses);
  return assessments;
}